<template>
  <ContainerWithErrorMessage :error-message="errorMessage">
    <v-field :label="label">
      <codemirror
        v-model="jsonString"
        :options="editorOptions"
        @update:model-value="validateJSON"
      />
    </v-field>
  </ContainerWithErrorMessage>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { Codemirror } from 'vue-codemirror'

import errorHandler from '@/api/ErrorHandler'
import ContainerWithErrorMessage from '@/components/common/ContainerWithErrorMessage.vue'

import { SchemaFormKitProps } from './formkit/types'

const model = defineModel<any>()
const props = defineProps<SchemaFormKitProps>()

const editorOptions = {
  // codemirror options
  tabSize: 4,
  mode: {
    name: 'javascript',
    json: true,
  },
  theme: 'base16-light',
  lineNumbers: true,
  line: true,
}
const jsonString = ref('')
const errorMessage = ref('')

onMounted(() => {
  if (model.value) {
    jsonString.value = JSON.stringify(model.value, null, 2)
  }
})

function validateJSON() {
  try {
    model.value = JSON.parse(jsonString.value)
    errorMessage.value = ''
  } catch (err) {
    errorMessage.value = errorHandler.errorToString(err)
  }
}

const label = computed(() => {
  return (
    props.field.templateOptions?.wrapper?.properties?.label ??
    props.field.properties.label ??
    ''
  )
})
</script>

<style lang="scss" scoped>
:deep(.cm-scroller) {
  overflow: 'auto';
}

:deep(.cm-editor) {
  max-height: 400px;
  background-color: #f5f5f5;
}
</style>
